<template>
  <div class="Zselect">
    <div class="select" @click='optionShowFn'>
      <input readonly type="text" v-model='showUse'>
      <span>
        <i></i>
      </span>
    </div>
    <div class="option" v-show='optionShow'>
      <ul>
        <li :class='showUse==i[values]?"optionCheckStyle":""' v-for='i in option' @click='Change(i)'>{{i[values]}}</li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Zselect',
  props:['option','indexs','values','vmodel','msg'],
  model: { 
      prop: 'msg',//被选中的参数值
      event: 'model'
    },
  data () {
    return {
      optionShow:false,//选项的显示隐藏
    }
  },
  computed: {
    // 被选中的显示
    showUse() {
      for(var i=0;i<this.option.length;i++){
        if(this.option[i][this.indexs] == this.msg){
          return this.option[i][this.values];
        }
      }
      return this.msg;
    }
  },
  watch:{
    // 下拉框的显示隐藏
    showUse(news,old) {
      this.optionShow = false;
    },
  },
  methods: {
    // 选择事件
    Change(data) {
      this.$emit('model', data.ids);//v-mode绑定的值
      this.$emit('ChangeOk', data);//选择的对象给父组件，以备使用
    },
    optionShowFn() {//选项的显示隐藏
      this.optionShow = (!this.optionShow)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less"> 
.Zselect{
  font-size: 0.24rem;
  display: inline-block;
  width: 100%;
  position: relative;
  .select{
    display: inline-block;
    height: 0.46rem;
    width: 100%;
    background: #f2f2f2;
    border:1px solid #bfbfbf;
    position: absolute;
    top: 0rem;
    input{
      font-size: 0.24rem;
      display: inline-block;
      width: 80%;
      height: 0.46rem;
      line-height: 0.46rem;
      position: absolute;
      left: 0;
      top: 0;
      text-indent: 0.12rem;
    }
    span{
      display: inline-block;
      width: 0.34rem;
      font-size: 0.46rem;
      height: 0.46rem;
      line-height: 0.46rem;
      position: absolute;
      right: 0;
      top: 0;
      background: #bfbfbf;
      text-align: center;
      i{
        display: inline-block;
        width: 0rem;
        height: 0rem;
        border: 0.08rem solid rgba(0,0,0,0);
        border-top: 0.08rem solid #fff;
      }
    }
  }
  .option{
    display: inline-block;
    width: 100%;
    background: #f2f2f2;
    border:1px solid #bfbfbf;
    position: absolute;
    top: 0.52rem;
    text-indent:0.12rem;
    ul{
      li{
        height: 0.46rem;
        line-height: 0.46rem;
        border-bottom: 1px solid #fff;
      }
    }
    .optionCheckStyle{
      background: #fff;
      border-left: 0.04rem #d50a1d solid;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/Zselect.vue